import { requestAutomatedRefund } from '@/compliance/services/nonComplianceService';
import { Button, Text, styled } from '@/theme/index';
import { useRedirect } from '@/utils/hooks/useRedirect';

const ComplianceUseAllowedContainer = styled('div')(({ theme }) => ({
  border: '0',
  borderRadius: '0 4px 4px 4px',
  boxShadow: 'none',
  flexGrow: '1',
  margin: '0',
  padding: `0 ${theme.spacing(2)} 0 ${theme.spacing(2)}`,
}));

const ProhibitedUseContent = styled('div')(({ theme }) => ({
  textAlign: 'center',
  width: '100%',

  [theme.breakpoints.up('sm')]: {
    width: 'auto',
  },
}));

export const ComplianceButton = styled(Button)(({ theme }) => ({
  marginLeft: '0',
  marginTop: theme.spacing(1.25),

  [theme.breakpoints.up('sm')]: {
    width: '100%',
  },
}));

export function ProhibitedUseLabel() {
  const { redirect } = useRedirect();

  function onToComplianceForm() {
    redirect('/compliance-form');
  }

  function requestRefund() {
    requestAutomatedRefund();
    redirect('/compliance-prohibited');
  }

  return (
    <ComplianceUseAllowedContainer>
      <ProhibitedUseContent>
        <Text mb={1} variant="h3" fontStyle="normal" fontWeight={700}>
          Is your use allowed?
        </Text>
        <Text variant="h6" fontWeight={300} margin="0">
          If “No” is selected, your account will be cancelled and refunded
        </Text>
      </ProhibitedUseContent>

      <div>
        <ComplianceButton
          variant="contained"
          color="success"
          fullWidth
          onClick={onToComplianceForm}
        >
          Yes
        </ComplianceButton>
        <ComplianceButton
          variant="outlined"
          color="success"
          fullWidth
          onClick={requestRefund}
        >
          No
        </ComplianceButton>
      </div>
    </ComplianceUseAllowedContainer>
  );
}
